import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import { SavedJob } from '../../stores/SavedJobsStore';
import DetailHeader from './components/DetailHeader.react';
import JobTasks from '../../components/job_form/JobTasks.react';
import { decompileConfigFromJob } from '../../util/helpers/jobManipulators';

const SavedJobRunAsUserDisplay = ({ runAsUserEmail }) => (
  <span>
    <label className='control-label'>Run As</label>
    <p className='saved-job-user'>{runAsUserEmail || 'No User Set'}</p>
  </span>
);

SavedJobRunAsUserDisplay.propTypes = {
  runAsUserEmail: PropTypes.string,
};

const SavedJobScheduleDisplay = ({ scheduleCronExpression }) => (
  <span>
    <label className='control-label'>Schedule Cron Expression</label>
    <p className='saved-job-schedule'>{scheduleCronExpression || 'No Schedule Set'}</p>
  </span>
);

SavedJobScheduleDisplay.propTypes = {
  scheduleCronExpression: PropTypes.string,
};

export default class SavedJobDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTask: null,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!Immutable.is(this.props.savedJob, nextProps.savedJob)) {
      this.setState({ activeTask: null });
    }
  }

  setActiveTask = (taskIndex) => {
    this.setState((prevState) => {
      const newTaskIndex = (taskIndex === prevState.activeTask ? null : taskIndex);
      return { activeTask: newTaskIndex };
    });
  }

  render() {
    const tasks = decompileConfigFromJob(this.props.savedJob.config);
    return (
      <article className='saved-job-detail'>
        <div className='detail'>
          <DetailHeader savedJobId={this.props.savedJob.id} />
          <label className='control-label'>Job Name</label>
          <p className='saved-job-name'>{this.props.savedJob.name}</p>
          { this.props.savedJob.scheduleCron &&
            <div>
              <SavedJobRunAsUserDisplay runAsUserEmail={this.props.savedJob.runAsUserEmail} />
              <SavedJobScheduleDisplay scheduleCronExpression={this.props.savedJob.scheduleCron} />
            </div>
          }
        </div>

        <JobTasks
          jobTasks={tasks}
          setActiveTask={this.setActiveTask}
          activeTask={this.state.activeTask}
          readOnly
        />
      </article>

    );
  }
}

SavedJobDetail.propTypes = {
  savedJob: PropTypes.instanceOf(SavedJob),
};
